import React, { Component, PureComponent } from 'react'
import classNames from 'classnames';

import IconButton from '@material-ui/core/IconButton';
import { withStyles, createMuiTheme, MuiThemeProvider, Theme } from '@material-ui/core/styles'

import { DatePicker } from "material-ui-pickers";
import moment from 'moment'
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import Menu from '@material-ui/core/Menu';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MaterialMenuItem from '@material-ui/core/MenuItem';
import { LookaheadNameKey } from '../selectors/lookahead.selector';
import { AreaCollection } from './AreaCollection';
const _ = require('lodash')


export interface Props {
	classes: ClassNameMap;
    selectedLookaheadId: String


}

export type State = {
}


class AreaScreen extends Component<Props, State> {
	pickerRef = null;

	constructor(props: Props) {
		super(props)

		this.state = {
            lookaheadListOpen: null,
            acceptedFile: [],
            rejectedFile: []
		}
	}
    




	render() {
		const { classes } = this.props
		return (
                <React.Fragment>

                    <AreaCollection />
                </React.Fragment>
		)
	}
}

export default AreaScreen;



// WEBPACK FOOTER //
// ./src/components/AreaScreen.tsx